var map = {
	"./advice/avoidcontact.png": 41,
	"./advice/disposablecloth.png": 42,
	"./advice/donttouchface.png": 43,
	"./advice/eyegear.png": 44,
	"./advice/facemask.png": 45,
	"./advice/generaladvice.png": 46,
	"./advice/keepdistance.png": 47,
	"./advice/medicalstaff.png": 48,
	"./advice/n95mask.png": 49,
	"./advice/shoecover.png": 50,
	"./advice/surgicalglove.png": 106,
	"./advice/surgicalgloves.png": 51,
	"./advice/washhands.png": 52,
	"./hotline/jabar.png": 53,
	"./hotline/jakarta.png": 54,
	"./hotline/jateng.png": 55,
	"./hotline/jatim.png": 56,
	"./hotline/kemenkes.png": 57,
	"./hotline/yogyakarta.png": 58,
	"./meninggal.png": 107,
	"./positif.png": 108,
	"./post/nu-01.png": 109,
	"./post/post-01.png": 59,
	"./post/post-02.png": 60,
	"./post/post-03.png": 61,
	"./post/post-04.png": 62,
	"./post/post-05.png": 63,
	"./post/post-06.png": 64,
	"./post/post-07.png": 65,
	"./post/post-08.png": 66,
	"./sembuh.png": 110,
	"./stayhome-logo.png": 21,
	"./trpl-logo.png": 111
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 105;